import FileSaver from 'file-saver';
import { push, replace } from 'redux-first-history';
import isEmpty from 'lodash.isempty';
import { apiActionCreator } from '../../actionCreators';
import {
    FETCH_ENROLLMENT_INFO,
    FETCH_SHARED_RESULTS,
    FETCH_ALL_INTERPS,
    FETCH_ALL_RESULTS,
    FETCH_R3D_INTERPS,
    FETCH_SHARED_INTERPS,
    FETCH_CHECKPOINTS,
    FETCH_D8_RESULTS,
    SELECT_STUDENT,
    FETCH_STUDENT_ENROLLMENT_INFO,
    SWITCH_PM_PERIOD,
    SWITCH_GRADE,
    FETCH_PDF_AVAILABILITY,
    SAVE_CHECKPOINT,
    SWITCH_PERIOD,
    CLEAR_ENROLLMENT_INFO,
    SWITCH_INSTRUCTION_GRADE,
    SWITCH_GROWTH_ANALYSIS_PERIOD,
    FETCH_STUDENT_GOALS,
    DOWNLOAD_PDF,
} from '../../actionTypes/shared/apiActionTypes';
import DEMO_MODE_ACTION_TYPES from '../../actionTypes/shared/demoModeActionTypes';
import {
    FETCH_READING_INTERPS,
    FETCH_READING_OBSERVATIONS,
    FETCH_INTERVENTIONS,
    FETCH_READING_RESULTS,
} from '../../actionTypes/reading/apiActionTypes';
import {
    DEMO_TYPES,
    DEMO_CLASS_2,
    STATIC_D8_RESULTS,
    STATIC_SPELL_RESULTS,
    STATIC_VOC_RESULTS,
    STATIC_RAN_RESULTS,
    STATIC_OL_RESULTS,
    STATIC_SUMMARY_GRADES,
    STATIC_ENROLLMENT_DATA,
    STATIC_CHECKPOINT_DATA,
    STATIC_MAZE_INTERP,
    STATIC_VOC_INTERP,
    STATIC_RAN_INTERP,
    STATIC_COMP_INTERP,
    STATIC_D8_INTERP,
    STATIC_SPELL_INTERP,
    STATIC_OBSERV_RES,
    STATIC_APP_CONFIG,
    STUDENT_ID,
    STATIC_OL_INTERP,
} from '../../../constants/reading/DemoModeConstants';
import selectors from '../../../root/shared/root';
import ToolTipsData from '../../../features/demoMode/reading/DemoModeHeader/DemoToolTips/ToolTips';
import StaticContentClient from '../../clients/shared/StaticContentClient';
import { clearResults } from '../../results/shared/resultActions';
import { clearCheckPoints } from '../../instruction/shared/instructionActions';
import { clearPercentileToggleState } from '../../percentiles/percentilesActions';
import { clearLexileToggleState } from '../../lexile/lexileActions';
import { PERIOD } from '../../../constants/shared/CommonConstants';
import { clearAdditionalEnrollmentInfo } from '../../enrollment/shared/enrollmentActions';
import { clearR3DInterps } from '../../interps/shared/interpActions';
import { clearStudentSummaryData } from '../../studentSummary/shared/studentSummaryActions';
import { clearBasicComprehensionWebEntryData } from '../../basicComprehensionWebEntry/shared/basicComprehensionWebEntryActions';

export const toolTips = { ...ToolTipsData };

const HOME_URL = '/reading-classroom-reports';
/* Action used to update location based on hardcoded tool tip "location" key in ToolTips json */
export const updateLocation = url => dispatch => {
    dispatch(push(url));
};

/* Clear user state */
const clearStateActions = () => async dispatch => {
    await dispatch({ type: CLEAR_ENROLLMENT_INFO });
    await dispatch(clearResults());
    await dispatch(clearCheckPoints());
    await dispatch(clearPercentileToggleState());
    await dispatch(clearAdditionalEnrollmentInfo());
    await dispatch(clearR3DInterps());
    await dispatch(clearLexileToggleState());
    await dispatch(clearStudentSummaryData());
    await dispatch(clearBasicComprehensionWebEntryData());
};

/* Sets the default PM history to BOY while in tour */
export const defaultPmPeriod = () => dispatch => {
    dispatch({ type: SWITCH_GROWTH_ANALYSIS_PERIOD, selectedGrowthAnalysisPeriod: PERIOD.BOY_MOY });
    dispatch({ type: SWITCH_PM_PERIOD, selectedPeriod: PERIOD.BOY_MOY });
};

/* Toggle On and Off Guidance Mode Transition */
export const setHasDemoTypeTransitionEnded = hasDemoTypeTransitionEnded => ({
    type: DEMO_MODE_ACTION_TYPES.SET_HAS_DEMO_TYPE_TRANSITION_ENDED,
    payload: hasDemoTypeTransitionEnded,
});

export const demoStudentGoalsData = () => dispatch =>
    dispatch({
        type: FETCH_STUDENT_GOALS.SUCCESS,
        response: [],
    });

export const demoFetchResultsData = (demoClass, demoData) => dispatch => {
    dispatch({ type: FETCH_D8_RESULTS.START });
    dispatch({
        type: FETCH_SHARED_RESULTS.OL_ENG,
        response: demoData[STATIC_OL_RESULTS[demoClass]],
    });
    dispatch({
        type: FETCH_SHARED_RESULTS.VOCABO_ENG,
        response: demoData[STATIC_VOC_RESULTS[demoClass]],
    });
    dispatch({
        type: FETCH_SHARED_RESULTS.SPELLING,
        response: demoData[STATIC_SPELL_RESULTS[demoClass]],
    });
    dispatch({
        type: FETCH_READING_RESULTS.RAN,
        response: demoData[STATIC_RAN_RESULTS[demoClass]],
    });
    dispatch({
        type: FETCH_SHARED_RESULTS.D8,
        response: demoData[STATIC_D8_RESULTS[demoClass]],
    });
    dispatch({ type: FETCH_ALL_RESULTS.SUCCESS });
};

export const demoFetchObservations = () => (dispatch, getState) => {
    const { demoData } = getState().demoMode;
    dispatch({ type: FETCH_READING_OBSERVATIONS.D8, response: demoData[STATIC_OBSERV_RES] });
};

export const demoSaveCheckPoint = () => dispatch => {
    dispatch({ type: SAVE_CHECKPOINT.SUCCESS, response: {} });
};

export const demoProcessCheckPoints = demoClass => (dispatch, getState) => {
    const { demoData } = getState().demoMode;
    const checkPointData = demoData[STATIC_CHECKPOINT_DATA[demoClass]];
    dispatch({ type: FETCH_CHECKPOINTS.SUCCESS, response: checkPointData });
};

export const fetchStudentDemoEnrollmentInfo = (studentId, demoClass) => (dispatch, getState) => {
    const { demoData } = getState().demoMode;
    const StudentSummaryGrade = demoData[STATIC_SUMMARY_GRADES[demoClass]];
    StudentSummaryGrade.data.getStudentEnrollment_v2[0].studentUid = studentId;
    dispatch({
        type: FETCH_STUDENT_ENROLLMENT_INFO.SUCCESS,
        response: StudentSummaryGrade.data.getStudentEnrollment_v2,
    });
};

const switchDemoGrade = () => dispatch => {
    dispatch(clearResults());
    dispatch(clearCheckPoints());
    dispatch(clearPercentileToggleState());
    dispatch(clearLexileToggleState());
    dispatch({ type: SWITCH_GRADE });
};

export const fetchDemoPdfAvailability = demoData => dispatch => {
    dispatch({
        type: FETCH_PDF_AVAILABILITY.SUCCESS,
        response: demoData[STATIC_APP_CONFIG].data.getApplicationConfig_v2,
    });
};

export const fetchDemoInterventions = () => dispatch => {
    dispatch({ type: FETCH_INTERVENTIONS.SUCCESS, response: {} });
};

/* Used when the Tooltip shows up to keep track for the demo tour */
export const setActiveTourStepId = tourStepId => (dispatch, getState) => {
    const { visitedTourSteps } = getState().demoMode;

    localStorage.setItem('activeTourStep', tourStepId);
    const visitedTourStepsPayload = visitedTourSteps.includes(tourStepId)
        ? visitedTourSteps
        : [...visitedTourSteps, tourStepId];
    localStorage.setItem('visitedTourSteps', JSON.stringify(visitedTourStepsPayload));
    dispatch({
        type: DEMO_MODE_ACTION_TYPES.SET_ACTIVE_TOUR_STEP_ID,
        activeTourStep: tourStepId,
        visitedTourStepsPayload,
    });
};

/* Interps */
export const demoFetchInterps = demoData => dispatch => {
    dispatch({
        type: FETCH_READING_INTERPS.D8_COMPOSITE,
        response: demoData[STATIC_COMP_INTERP],
    });
    dispatch({ type: FETCH_READING_INTERPS.D8, response: demoData[STATIC_D8_INTERP] });
    dispatch({ type: FETCH_READING_INTERPS.RAN, response: demoData[STATIC_RAN_INTERP] });
    dispatch({ type: FETCH_READING_INTERPS.MAZE, response: demoData[STATIC_MAZE_INTERP] });
    dispatch({
        type: FETCH_SHARED_INTERPS.SPELLING,
        response: demoData[STATIC_SPELL_INTERP],
    });
    dispatch({
        type: FETCH_SHARED_INTERPS.VOCABO,
        response: demoData[STATIC_VOC_INTERP],
    });
    dispatch({
        type: FETCH_SHARED_INTERPS.OL,
        response: demoData[STATIC_OL_INTERP],
    });
    dispatch({ type: FETCH_ALL_INTERPS.SUCCESS });
};

export const fetchDemoR3DInterps = () => dispatch => {
    dispatch({ type: FETCH_R3D_INTERPS.SUCCESS, response: {} });
};

/* Get Enrollment Data */
export const demoFetchEnrollmentData = (demoClass, demoData) => (dispatch, getState) => {
    const { visitedTourSteps } = getState().demoMode;
    const EnrollmentDemoData = demoData[STATIC_ENROLLMENT_DATA[demoClass]];
    const additionalParams = {
        district:
            EnrollmentDemoData.data.getEnrollmentResolvers_v2.enrollmentData.chosenDistrictUid,
        school: EnrollmentDemoData.data.getEnrollmentResolvers_v2.enrollmentData.chosenSchoolUid,
        classe: EnrollmentDemoData.data.getEnrollmentResolvers_v2.enrollmentData.chosenClasseUid,
        period: visitedTourSteps.length > 4 ? PERIOD.BOY : PERIOD.MOY, // Set period pending which step you are on
        burstGroupUid: null,
    };
    dispatch({
        type: FETCH_ENROLLMENT_INFO.SUCCESS,
        response: EnrollmentDemoData.data.getEnrollmentResolvers_v2,
        additionalResponseParams: additionalParams,
    });
};

const initializeDemoMode = (demoClass, demoData) => async dispatch => {
    const grade = demoClass.length > 0 ? demoClass : '2';
    await dispatch({ type: SWITCH_INSTRUCTION_GRADE, selectedInstructionGrade: null });
    await dispatch(demoFetchEnrollmentData(grade, demoData));
    await dispatch(demoFetchResultsData(grade, demoData));
    await dispatch(demoFetchInterps(demoData));
    await dispatch(fetchDemoPdfAvailability(demoData));
    await dispatch(demoStudentGoalsData());
    await dispatch(fetchDemoR3DInterps());
    await dispatch(defaultPmPeriod());
    await dispatch(demoProcessCheckPoints(demoClass));
};

/* LOAD DEMO DATA */
export const loadDemoData = () => async (dispatch, getState) => {
    const { demoData, demoClass } = getState().demoMode;
    if (isEmpty(demoData)) {
        try {
            dispatch({ type: FETCH_ENROLLMENT_INFO.START });
            const staticDemoData = await StaticContentClient.getAllDemoData();
            await dispatch({
                type: DEMO_MODE_ACTION_TYPES.LOAD_DEMO_DATA,
                payload: staticDemoData,
            });
            await dispatch(initializeDemoMode(demoClass, staticDemoData));
        } catch (error) {
            await dispatch({
                type: DEMO_MODE_ACTION_TYPES.LOAD_DEMO_ERROR,
                payload: error.message,
            });
        }
    } else {
        await dispatch(initializeDemoMode(demoClass, demoData));
    }
};

/* Used in DemoBar to switch between different grades */
export const setDemoClass = (demoClass, isTourResumedOnSpecificSteps) => (dispatch, getState) => {
    const state = getState();
    const { demoData } = state.demoMode;
    const { search } = selectors.getLocation(state);

    // omit the redirect in case setDemoClass func was triggered by a click on "resume" btn
    if (search.includes(STUDENT_ID) && !isTourResumedOnSpecificSteps) {
        // Check if the user is on a specific student page and if so send them to the home page
        dispatch(updateLocation(HOME_URL));
    }
    dispatch(initializeDemoMode(demoClass, demoData));
    dispatch({
        type: DEMO_MODE_ACTION_TYPES.SET_DEMO_CLASS,
        payload: demoClass,
    });
    localStorage.setItem('demoClass', demoClass);
    dispatch(switchDemoGrade());
};

// When user clicks start over reset to step-0
export const resetTour = () => async dispatch => {
    await dispatch({
        type: DEMO_MODE_ACTION_TYPES.RESET_TOUR,
    });
    await dispatch({ type: SWITCH_PERIOD, selectedPeriod: PERIOD.MOY });
    await dispatch(defaultPmPeriod());
    await dispatch(push(HOME_URL));
    dispatch(setDemoClass(DEMO_CLASS_2));
};

/* Toggle On and Off Guidance Mode and Self Explore */
export const setDemoType = (demoType, isTourResumedOnSpecificSteps) => dispatch => {
    dispatch({ type: DEMO_MODE_ACTION_TYPES.SET_DEMO_TYPE, payload: demoType });
    if (demoType === DEMO_TYPES.GUIDED_TOUR) {
        dispatch(setDemoClass(DEMO_CLASS_2, isTourResumedOnSpecificSteps));
    }
    if (demoType === DEMO_TYPES.SELF_EXPLORE || demoType === DEMO_TYPES.DEFAULT) {
        dispatch(setHasDemoTypeTransitionEnded(false));
    }
};

/* Exiting demo mode back to users data view */
export const exitDemoMode =
    (resetTourBool, shouldAppReload = true) =>
    (dispatch, getState) => {
        const { isGuidedTourOn } = getState().demoMode;
        if (isGuidedTourOn) {
            dispatch(setDemoType(DEMO_TYPES.SELF_EXPLORE));
        }
        localStorage.setItem('inDemo', false);
        dispatch({ type: DEMO_MODE_ACTION_TYPES.CLOSE_DEMO });
        if (shouldAppReload) {
            dispatch(replace(HOME_URL));
            window.location.reload();
        }
        if (resetTourBool) {
            dispatch({
                type: DEMO_MODE_ACTION_TYPES.RESET_TOUR,
            });
        }
    };

/* Used when clicking on a particular student in student summary to select given student */
export const selectDemoStudent = selectedStudentId => dispatch =>
    dispatch({
        type: SELECT_STUDENT,
        selectedStudentId,
    });

/* Canel tool tip and go back to self explore */
export const cancelToolTip = () => dispatch => {
    dispatch(setDemoType(DEMO_TYPES.SELF_EXPLORE));
};

/* Launch Demo Mode  */
export const launchDemoMode = () => async dispatch => {
    await dispatch(clearStateActions());
    await dispatch({ type: DEMO_MODE_ACTION_TYPES.LAUNCH_DEMO });
    await dispatch(updateLocation(HOME_URL));
    await dispatch(loadDemoData());
};

/* Download static PDF from Print menu */
export const downloadDemoPdf = (url, pdfFileName) => async dispatch => {
    const additionalApiParams = {
        afterApiCallCalback: async response => {
            await FileSaver.saveAs(new Blob([response], { type: 'application/pdf' }), pdfFileName);
        },
        apiParams: [url],
    };
    await apiActionCreator(
        dispatch,
        DOWNLOAD_PDF,
        StaticContentClient.getPdfDemoData,
        additionalApiParams,
    );
};
